function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a{stroke:#40516f;}\n      .a,.b{stroke-width:4px;fill:rgba(255,255,255,0)}\n      .b{fill:none;stroke:#c89e00;stroke-linecap:round;stroke-linejoin:round;}\n    "));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 77.91,
  cy: 77.91,
  r: 75.91
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M114.13,53.91,67.58,100.45a5,5,0,0,1-7.07,0L41.7,81.65"
});

var SvgNoAlarms = function SvgNoAlarms(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 155.83 155.83",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoAlarms, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noAlarms.c8652d87.svg";
export { ForwardRef as ReactComponent };